import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { PageTwoFormData } from "../models";

const schema = yup.object().shape({
  preAdmissionDiet: yup.string(),
  foodAllergies: yup.string(),
  appetitChange: yup.string(),
  foodIntolerance: yup.string(),
  chewingSwallowingDifficulty: yup.string(),
  weightLossLastMonth: yup.string(),
  howMuchWeightLoss: yup.string(),
  hasPreviousTransfusion: yup.string(),
  previousTransfusionReaction: yup.string(),
  isIsolated: yup.string(),
  isolationType: yup.string(),
  reasonForIsolation: yup.string(),
  
  // Requests Section
  hasReligiousNeeds: yup.string(),
  religiousNeedsDetails: yup.string(),
  hasPrivacyRequest: yup.string(),
  privacyRequestDetails: yup.string(),
  hasSpecialCoveringPref: yup.string(),
  coveringPrefDetails: yup.string(),
  hasSpecialClothingPref: yup.string(),
  clothingPrefDetails: yup.string(),
  personalBelongsKeptBy: yup.string(),

  // Discharge Section
  socialWorkConsultation: yup.string(),
  homeHelpPostDischarge: yup.string(),
  homeLivingConditions: yup.string(),
  whoWillProvideCare: yup.string(),
  livingAloneAfterDischarge: yup.string(),
  medicalDurableEquipNeed: yup.string(),
  transferredToAnotherFacility: yup.string(),
  dischargeLivingConditionsDesc: yup.string(),

  // Catheters
  existingCatheters: yup.string(),
  ivCatheterDate: yup.string(),
  umbilicalCatheterDate: yup.string(),
  otherCatheterDesc: yup.string(),
  familyPresenceDuringCatheter: yup.string(),
  familyPresenceDesc: yup.string(),

  // Oncology
  whoPerformanceScore: yup.string(),
  isInformedAboutTreatment: yup.string(),
  isInformedAboutMedicationRights: yup.string(),
});

export const usePageTwoForm = () => {
  const formMethods = useForm<PageTwoFormData>({
    resolver: yupResolver(schema),
    defaultValues: {
      preAdmissionDiet: "",
      appetitChange: "",
      weightLossLastMonth: "",
      hasPreviousTransfusion: "",
      isIsolated: "",
      isolationType: "",
      hasReligiousNeeds: "",
      hasPrivacyRequest: "",
      isInformedAboutTreatment: "unknown",
      isInformedAboutMedicationRights: "unknown",
    },
  });

  const { handleSubmit } = formMethods;

  const normalizeData = (data: PageTwoFormData) => {
    const normalized = { ...data } as any;
    Object.keys(normalized).forEach((key) => {
      if (typeof normalized[key] === "string") {
        normalized[key] = normalized[key].trim();
      }
    });
    return normalized as PageTwoFormData;
  };

  const onSubmit = handleSubmit((data) => {
    console.log("Page Two Form Data:", normalizeData(data));
  });

  return {
    formMethods,
    onSubmit,
  };
};
